import React from "react"
import { 
  Button, 
  OverlayTrigger,
  Tooltip
} from "react-bootstrap"
import {
  HiDownload
} from 'react-icons/hi'
import {
  ButtonCreateInterface
} from '../ButtonCreate'

export const ButtonDownload: React.FC <ButtonCreateInterface> = ({
  text,
  noText = false,
  variant,
  tooltip = true,
  tooltipText,
  tooltipPlacement,
  size = 'sm',
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={tooltip ? <Tooltip>{tooltipText ?? 'Download data'}</Tooltip> : <div></div>}
    >
      <Button
        {...rest}
        size={size === "sm" ? "sm" : size === "lg" ? "lg" : undefined}
        variant={variant ?? "secondary"}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div>
            <HiDownload className="mb-1" />
          </div>
          {!noText && (
            <span className="mx-1 text-uppercase">
              {text  ? text : 'Download'}
            </span>
          )}
        </div>
      </Button>
    </OverlayTrigger>
  )
}